import { Button, Popover } from 'antd';
import { useState } from 'react';

import type { PopoverProps } from 'antd';
import type { ReactNode } from 'react';

type HeaderIconPopoverProps = {
  icon: ReactNode;
  ariaLabel: string;
  /** Popover body. Use the render form to close the popover from inside. */
  content: ReactNode | ((close: () => void) => ReactNode);
  placement?: PopoverProps['placement'];
  popoverStyles?: PopoverProps['styles'];
  buttonTestId?: string;
};

const HeaderIconPopover = ({
  icon,
  ariaLabel,
  content,
  placement = 'rightBottom',
  popoverStyles,
  buttonTestId,
}: HeaderIconPopoverProps) => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <Popover
      content={typeof content === 'function' ? content(close) : content}
      trigger="click"
      placement={placement}
      open={open}
      onOpenChange={setOpen}
      arrow={false}
      styles={popoverStyles}
    >
      <Button
        size="large"
        variant={open ? 'filled' : 'link'}
        color={open ? 'primary' : 'default'}
        shape="circle"
        aria-label={ariaLabel}
        data-testid={buttonTestId}
        icon={icon}
      />
    </Popover>
  );
};

export default HeaderIconPopover;
